import axios from "axios";
import { API_URL } from './service';

export const getSurveyGraph = (surveyId: string, token: string) => {
  return axios.get(API_URL + `surveys/${surveyId}/nodes`, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const getSurveyQuestion = (surveyId: string, token: string, question: string) => {
  return axios.get(API_URL + `surveys/${surveyId}/edges/${question}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
};


export const getLegend = (token: string) => {
  return fetch(API_URL + 'graphs/legend', {
    method: "GET",
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const getRespondentStats = (surveyId: string, question: string, respondent: string, token: string) => {
  return axios.get(API_URL + `surveys/${surveyId}/edges/${question}/respondent/${respondent}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const getSurveyInfo = (surveyId: string, token: string) => {
  return axios.get(API_URL + `surveys/${surveyId}/stats`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const getSurveyList = (token: string) => {
  return axios.get(API_URL + "surveys", {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const getExcelReport = (surveyId: string, token: string) => {
  return axios.get(API_URL + `surveys/${surveyId}/report`, {
    headers: { Authorization: `Bearer ${token}` },
    responseType: 'blob'
  });
};
